import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

import MainContainer from "../../layout/MainContainer";
import { errorToast, successToast } from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import Loader from "../../constants/Loader";

import {
  useUpdateCountryMutation,
  useAddCountryMutation,
  useLazyCountryDetailsQuery,
} from "../../service/countries";
import { isString, isValidInput } from "../../utils/validations";

const AddCountries = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [getCountryDetails] = useLazyCountryDetailsQuery();
  const [addCountry] = useAddCountryMutation();
  const [updateCountry] = useUpdateCountryMutation();

  const getDetails = async (id: number) => {
    setLoading(true);

    try {
      const response = await getCountryDetails({
        id,
      }).unwrap();
      setLoading(false);
      if (response?.status === 200) {
        formik.setFieldValue("country_name", response?.data?.country_name);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      country_name: "",
    },

    validationSchema: Yup.object({
      country_name: Yup.string()
        .required("Country name is required")
        .min(2, "Minimum 2 characters are required"),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);

      const body = {
        country_name: values.country_name,
      };

      try {
        setLoading(true);
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        let response;
        if (id) {
          response = await updateCountry({
            body: encryptedBody,
            id: Number(id),
          }).unwrap();
        } else {
          response = await addCountry(encryptedBody).unwrap();
        }

        if (response?.status === 200) {
          setLoading(false);
          if (id) {
            successToast("Country updated successfully");
          } else {
            successToast("Country added successfully");
          }
          navigate("/manage-countries");
        } else {
          setLoading(false);
        }
      } catch (error: any) {
        errorToast(error?.data?.message || "");
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (id) {
      getDetails(Number(id));
    }
  }, [id]);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title fdx">
        <div>
          <h1>{id ? "Edit" : "Add"} Countries</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-countries")}>Countries</span>{" "}
            - {id ? "Edit" : "Add"} Country
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_blue" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="gap_p">
            <div className="control_group w_50">
              <label>Country Name</label>
              <TextField
                variant="outlined"
                placeholder="Country Name"
                fullWidth
                hiddenLabel
                className="text_field"
                name="country_name"
                id="country_name"
                inputProps={{ maxLength: 40 }}
                value={formik.values.country_name}
                onChange={(val) => {
                  if (
                    isValidInput(val.target.value) &&
                    isString(val.target.value)
                  ) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.country_name && formik.errors.country_name
                }
              />
            </div>
            {/* <div className="control_group w_50">
              <label>Citizenship</label>
              <TextField
                variant="outlined"
                placeholder="Citizenship"
                fullWidth
                hiddenLabel
                className="text_field"
                name="country_name"
                id="country_name"
                inputProps={{ maxLength: 40 }}
                value={formik.values.country_name}
                onChange={(val) => {
                  if (
                    isValidInput(val.target.value) &&
                    isString(val.target.value)
                  ) {
                    formik.handleChange(val);
                  }
                }}
                onBlur={formik.handleBlur}
                helperText={
                  formik.touched.country_name && formik.errors.country_name
                }
              />
            </div> */}
          </div>

          <div className="form_end_btn">
            <Button className="btn btn_secondary" type="submit">
              Submit
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddCountries;
